import { cn } from "@/shared/lib/utils"
import { SLEEP_TYPES, type SleepType } from "./sleep.config"

interface SleepTypeSelectorProps {
  value: SleepType
  onChange: (value: SleepType) => void
}

// Three-up chip grid for picking a sleep type. Toggle chips, not CTAs — styled <button>s.
export function SleepTypeSelector({ value, onChange }: SleepTypeSelectorProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {SLEEP_TYPES.map(({ value: type, label, icon: Icon }) => {
        const selected = type === value
        return (
          <button
            key={type}
            type="button"
            onClick={() => onChange(type)}
            className={cn(
              "flex flex-col items-center gap-1 rounded-lg border py-2 text-xs transition-colors",
              selected
                ? "border-accent bg-accent/15 text-foreground"
                : "border-border text-muted-foreground hover:text-foreground",
            )}
          >
            <Icon className="size-5" />
            {label}
          </button>
        )
      })}
    </div>
  )
}
